var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "mb-0 p-2 pr-5 has-shadow has-background-info is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center floating-actions-container",
    },
    [
      _vm.isDropdownOpen ? _c("div", { staticClass: "bg-overlay" }) : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "has-text-white" }, [
        _c("b", [_vm._v(_vm._s(_vm.selectedDocumentsIndex.length))]),
        _vm._v(" archivos seleccionados"),
        _c(
          "a",
          {
            staticClass: "has-text-white ml-3",
            on: { click: _vm.unselectDocuments },
          },
          [
            _c("i", { staticClass: "fas fa-times-circle fa-fw" }),
            _vm._v(" Limpiar"),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.selectedDocumentsIndex.length > 0
        ? _c(
            "div",
            [
              _c(
                "b-dropdown",
                {
                  staticClass: "is-hidden-desktop",
                  attrs: { "aria-role": "list", position: "is-bottom-left" },
                  on: { "active-change": (b) => (_vm.isDropdownOpen = b) },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function ({ active }) {
                          return _c(
                            "a",
                            {
                              staticClass:
                                "has-text-white has-text-weight-bold",
                              attrs: { role: "button" },
                            },
                            [
                              _vm._v("\n        Acciones  "),
                              _c("i", {
                                staticClass: "fas",
                                class: {
                                  "fa-angle-down": !active,
                                  "fa-angle-up": active,
                                },
                              }),
                            ]
                          )
                        },
                      },
                    ],
                    null,
                    false,
                    3719450673
                  ),
                },
                [
                  _vm._v(" "),
                  _vm.everyIsSignable
                    ? _c(
                        "b-dropdown-item",
                        { attrs: { "aria-role": "listitem" } },
                        [
                          _c("i", { staticClass: "fas fa-plus fa-fw fa-lg" }),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                          _vm._v(" Agregar para firmar"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "aria-role": "listitem" },
                      on: { click: _vm.moveDocuments },
                    },
                    [
                      _c("i", { staticClass: "fas fa-dolly fa-fw fa-lg" }),
                      _vm._v(" Mover"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "aria-role": "listitem" },
                      on: { click: _vm.deleteDocuments },
                    },
                    [
                      _c("i", { staticClass: "fas fa-trash fa-fw fa-lg" }),
                      _vm._v(" Eliminar"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }